import { del, getAuthenticatedRequestConfig } from '../client'
import { removeTokenByDeviceIdSerializer } from '../../serializers/removeTokenByDeviceIdSerializer'

export const removeTokenByDeviceIdResource = (params = {}) => {
  const { deviceId } = params

  return del(`/v1/subscribers/by_device/${deviceId}`, { ...params })
    .then((response) => removeTokenByDeviceIdSerializer(response))
    .catch((error) => Promise.reject(error))
}

export const removeAuthenticatedTokenByDeviceIdResource = (
  baseURL,
  authToken,
  authHeader,
  authScheme,
  params = {}
) => {
  const requestConfig = getAuthenticatedRequestConfig(
    baseURL,
    authToken,
    authHeader,
    authScheme,
    params
  )

  return removeTokenByDeviceIdResource(requestConfig)
}

export default removeTokenByDeviceIdResource
